import { sBanner } from '../../shared.min.js';

const carTheftWidget = (function () {
	let calc,
		form,
		claimResult,
		restartButton,
		bannerStep,
		bannerText,
		airlineDropdown,
		classDropdown,
		classDropdownField,
		continueButton;

	const resultText = document.getElementById('cba-cms'),
		bannerStep1Text = resultText.getAttribute('data-banner-step-1-text'),
		bannerStep2Text = resultText.getAttribute('data-banner-step-2-text'),
		selectAirlineText = resultText.getAttribute('data-dropdown-select-airline'),
		selectClassText = resultText.getAttribute('data-dropdown-select-class'),
		handLuggageTitle = resultText.getAttribute('data-result-hand-luggage-title'),
		handLuggageIncludedTicket = resultText.getAttribute('data-result-hand-luggage-included-ticket'),
		handLuggageAdditionFees = resultText.getAttribute('data-result-hand-luggage-included-ticket'),
		holdLuggageTitle = resultText.getAttribute('data-result-hold-luggage-title'),
		holdLuggageIncludedTicket = resultText.getAttribute('data-result-hold-luggage-included-ticket'),
		holdLuggageAdditionalCase = resultText.getAttribute('data-result-hold-luggage-additional-case');

	const holdLuggageExcessWeight = resultText.getAttribute('data-result-hold-luggage-excess-weight');

	async function init() {
		const data = await fetch(document.getElementById('cba-json').getAttribute('data-json-path'));
		const jsonData = await data.json();
		jsonData.sort((a, b) => sortByString(a.airline, b.airline));

		calc = document.getElementById('cnfsd-cba-widget');
		form = document.getElementById('cnfsd_cba-form');
		claimResult = document.getElementById('cnfsd_cba-result');
		bannerStep = calc.querySelector('.banner-current-progress');
		bannerText = calc.querySelector('.banner-current-text');
		airlineDropdown = document.getElementById('cnfsd_cba-airline');
		classDropdown = document.getElementById('cnfsd_cba-class');
		classDropdownField = document.getElementById('cnfsd_cba-class-field');
		continueButton = document.getElementById('cnfsd_cba-continue');
		restartButton = calc.querySelector('a.arrow-link--back');

		sBanner(
			calc,
			[bannerStep1Text, bannerStep2Text],
			'.banner-current-text',
			'.banner-current-progress',
			'.banner__progress-bar__bar',
			1
		);

		function restartCalc() {
			airlineDropdown.innerHTML = `<option selected="selected" disabled="disabled" value="">${selectAirlineText}</option>`;
			classDropdown.innerHTML = `<option selected="selected" disabled="disabled" value="">${selectClassText}</option>`;
			classDropdownField.classList.add('display-none');
			continueButton.classList.add('display-none');
			swapUi();
			sBanner(
				calc,
				[bannerStep1Text, bannerStep2Text],
				'.banner-current-text',
				'.banner-current-progress',
				'.banner__progress-bar__bar',
				1
			);
			populateAirlineDropdown();
		}

		function populateAirlineDropdown() {
			jsonData.forEach(item => {
				const option = document.createElement('option');
				option.value = item.airline;
				option.text = item.airline;
				airlineDropdown.appendChild(option);
			});

			// Add event listener to populate the class when a airline is selected
			airlineDropdown.addEventListener('change', function () {
				continueButton.classList.add('display-none');
				populateClassDropdown(this.value);
			});
		}

		function populateClassDropdown(selectedAirline) {
			// Clear the current options
			classDropdown.innerHTML = `<option selected="selected" disabled="disabled" value="">${selectClassText}</option>`;

			// Find the selected airline's class and populate the dropdown
			const selectedAirlineData = jsonData.find(item => item.airline === selectedAirline);
			if (selectedAirlineData && selectedAirlineData.class[0].name !== null) {
				selectedAirlineData.class.sort((a, b) => sortByString(a.name, b.name));

				selectedAirlineData.class.forEach(classItem => {
					const option = document.createElement('option');
					option.value = classItem.name;
					option.text = classItem.name;
					classDropdown.appendChild(option);
				});
				classDropdownField.classList.remove('display-none');
				classDropdown.addEventListener('change', function () {
					continueButton.classList.remove('display-none');
				});
			} else {
				classDropdownField.classList.add('display-none');
				continueButton.classList.remove('display-none');
			}
		}

		function showResult() {
			const baggageResults = document.getElementById('baggage-results');
			const baggageResultsTitle = document.getElementById('baggage-results-title');
			const airLineLink = document.getElementById('cba-airLineLink');
			const airLineNotes = document.getElementById('cba-airLineNotes');

			const selectedAirline = airlineDropdown.value;
			const selectedClass = classDropdown.value;

			// Find the selected airline and class
			const selectedAirlineData = jsonData.find(item => item.airline === selectedAirline);
			const selectedClassData = selectedAirlineData.class.find((item, index) =>
				!selectedClass ? index === 0 : item.name === selectedClass
			);

			let baggageTitle = `${selectedAirline}`;

			if (selectedClass) {
				baggageTitle = `${selectedAirline} - ${selectedClass}`;
			}

			baggageResultsTitle.textContent = baggageTitle;

			const handLuggageItems = selectedClassData.handLuggage;
			const handLuggageListItems = handLuggageItems.map(item => `<li>${item}</li>`).join('');
			let additionalHandHtml = ``;

			if (selectedClassData.handLuggageAdditional && selectedClassData.handLuggageAdditional.length > 0) {
				const handLuggageAdditionFeesItems = selectedClassData.handLuggageAdditional;
				const handLuggageAdditionFeesListItems = handLuggageAdditionFeesItems
					.map(item => `<li>${item}</li>`)
					.join('');

				additionalHandHtml = `
					<h6>${handLuggageAdditionFees}</h6>
					<ul>
						${handLuggageAdditionFeesListItems}
					</ul>
				`;
			}

			const handLuggage = `
			<div class="card--light">
				<h2 class="icon--before travel-icon--hand--colour">${handLuggageTitle}</h2>
				<h6>${handLuggageIncludedTicket}</h6>
				<ul>
					${handLuggageListItems}
				</ul>
				${additionalHandHtml}
			</div>
			`;

			baggageResults.innerHTML = handLuggage;

			if (selectedClassData.holdLuggage && selectedClassData.holdLuggage.length > 0) {
				const holdLuggageItems = selectedClassData.holdLuggage;
				const holdLuggageListItems = holdLuggageItems.map(item => `<li>${item}</li>`).join('');
				let additionalCaseHtml;
				let excessWeightFeesHtml;

				if (selectedClassData.additionalCase && selectedClassData.additionalCase.length > 0) {
					const additionalCaseItems = selectedClassData.additionalCase;
					const additionalCaseListItems = additionalCaseItems.map(item => `<li>${item}</li>`).join('');

					additionalCaseHtml = `
						<h6>${holdLuggageAdditionalCase}</h6>
						<ul>
							${additionalCaseListItems}
						</ul>
					`;
				}

				if (selectedClassData.excessWeightFees && selectedClassData.excessWeightFees.length > 0) {
					const excessWeightFeesItems = selectedClassData.excessWeightFees;
					const excessWeightFeesListItems = excessWeightFeesItems.map(item => `<li>${item}</li>`).join('');
					let holdLuggageExcessWeightTitle = holdLuggageExcessWeight;
					if (selectedClassData.notes) {
						holdLuggageExcessWeightTitle = `${holdLuggageExcessWeight}***`;
					}

					excessWeightFeesHtml = `
						<h6>${holdLuggageExcessWeightTitle}</h6>
						<ul>
							${excessWeightFeesListItems}
						</ul>
					`;
				}

				const holdLuggage = `
				<div class="card--light spacer-top-sm">
					<h2 class="icon--before travel-icon--hold--colour">${holdLuggageTitle}</h2>
					<h6>${holdLuggageIncludedTicket}</h6>
					<ul>
						${holdLuggageListItems}
					</ul>
					${additionalCaseHtml}
					${excessWeightFeesHtml}
				</div>
				`;

				baggageResults.innerHTML += holdLuggage;
			}

			if (selectedClassData.webPage) {
				airLineLink.textContent = `${selectedClassData.webPage}`;
				airLineLink.href = selectedClassData.webPage;
			}

			if (selectedClassData.notes) {
				airLineNotes.textContent = `***${selectedClassData.notes}`;
			}

			claimResult.classList.remove('display-none');
			form.classList.add('display-none');
			sBanner(
				calc,
				[bannerStep1Text, bannerStep2Text],
				'.banner-current-text',
				'.banner-current-progress',
				'.banner__progress-bar__bar',
				2
			);
		}

		function swapUi() {
			claimResult.classList.toggle('display-none');
			form.classList.toggle('display-none');
		}

		populateAirlineDropdown();

		continueButton.addEventListener('click', function (e) {
			e.preventDefault();
			showResult();
		});

		restartButton.addEventListener('click', e => {
			e.preventDefault();
			restartCalc();
		});
	}

	function sortByString(a, b) {
		if (a < b) {
			return -1;
		}
		if (a > b) {
			return 1;
		}
		return 0;
	}

	return {
		init: init,
	};
})();

document.addEventListener('DOMContentLoaded', function () {
	carTheftWidget.init();
});
